import { ApiRequest } from 'src/helpers';
import { API_END_POINTS } from 'src/constants';

export function getCheckoutDetail(data = {}) {
  return ApiRequest.fetch({
    method: 'get',
    url: `${API_END_POINTS.ONE_CLICK_CHECKOUT}/${data?.uuid}`,
    headers: data?.headers,
  }).then((response) => response?.data);
}

export function generateCheckoutPayment(data = {}) {
  return ApiRequest.fetch({
    method: 'post',
    url: API_END_POINTS.GENERATE_CHECKOUT_PAYMENT.replace('{UUID}', data?.uuid),
    data: data?.body,
    headers: data?.headers,
  }).then((response) => response.data);
}

export function generateCheckoutPaymentSip(data = {}) {
  return ApiRequest.fetch({
    method: 'post',
    url: API_END_POINTS.GENERATE_CHECKOUT_PAYMENT_SIP.replace('{UUID}', data?.uuid),
    data: data?.body,
    headers: data?.headers,
  }).then((response) => response.data);
}
